









import Vue, { PropType } from 'vue'

import { WidgetRow } from '../widgets/base'
import ElementTreePanelRowControls from './ElementTreePanelRowControls.vue'
import ElementTreePanelRowWidget from './ElementTreePanelRowWidget.vue'

export default Vue.extend({
  components: {
    ElementTreePanelRowControls,
    ElementTreePanelRowWidget
  },
  props: {
    row: {
      type: Object as PropType<WidgetRow>,
      required: true,
      default: {}
    },
    index: {
      type: Number,
      required: true,
      default: 1
    },
    selectedWidgetUUID: {
      type: Array,
      required: false,
      default: []
    }
  },
  computed: {
    isRowExpanded() {
      return this.selectedWidgetUUID.indexOf(this.row.wbUUID!) > -1
    },
    orderedWidgets() {
      if (!this.row.widgets) return []

      const orderedWidgets = JSON.parse(JSON.stringify(this.row.widgets))
      return orderedWidgets.sort((a, b) => a.sortindex - b.sortindex)
    }
  },
  data() {
    return {
      isHovering: false
    }
  },
  methods: {
    onHover() {
      this.isHovering = true
    },
    onUnhover() {
      this.isHovering = false
    }
  }
})
